import React from 'react';
import {LocalesOnFolder} from './ParentLocales.style';
import {t} from 'i18next';
import {join} from 'lodash';
import {generateIdentifier} from '../../utils/IdentityUtils';
import {Accordion} from '../Accordion/LocalizedAccordion';

export interface ParentLocalesProps {
    readonly parentLocales: string[]
}

/**
 * @name ParentLocales
 * @description
 * Component to render inherited locales from parent item
 */
export const ParentLocales: React.VFC<ParentLocalesProps> = (props) => {
    return (
        <Accordion localizedHeadline={t('CREATE_EDIT_FOLDER_DIALOG_POSSIBLE_LOCALES')}>
            <LocalesOnFolder id={generateIdentifier()}>
                {join(props.parentLocales, ',  ')}
            </LocalesOnFolder>
        </Accordion>
    );
};